// extracted by mini-css-extract-plugin
export default {"wrapper":"PaymentDetailsPage_wrapper__9gaow","actions":"PaymentDetailsPage_actions__uvCM4","fee":"PaymentDetailsPage_fee__KkiwS"};